import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { axios } from 'utils/axios';
import {
  AiSubscriptionCheckoutRequest,
  AiSubscriptionCheckoutResponse,
} from 'types/AiSubscription';

const createAiSubscriptionCheckout = async (
  checkoutData: AiSubscriptionCheckoutRequest
): Promise<AiSubscriptionCheckoutResponse> => {
  const { data } = await axios.post<AiSubscriptionCheckoutResponse>(
    '/ai-subscription/checkout',
    checkoutData
  );
  return data;
};

export const useAiSubscriptionCheckout = (): UseMutationResult<
  AiSubscriptionCheckoutResponse,
  unknown,
  AiSubscriptionCheckoutRequest,
  unknown
> => {
  return useMutation({
    mutationFn: createAiSubscriptionCheckout,
  });
};
